export default (theme) => ({
    mainHeading: {
        marginBottom: '20px !important',
        color: 'var(--grey-110)'
    },
    fieldLoader: {
        height: '65px !important', 
        borderRadius: '27px !important',
        '&:not(&:first-child)': {
            marginTop: '-17px !important',
        }
    },
    autoCompleteField: {
        '& input': {
            padding: '0px 5px !important'
        }
    },
    section: {
        marginTop: 30
    },
    contactInformationHeading: {
        color: theme.palette.colors.ceruleanMain,
        letterSpacing: '1.6px'
    },
    textInput: {
        margin: "6px 0px !important",
    },
    imgText: {
        color: 'var(--grey-100)'
    },
    phoneNumber: {
        position: 'relative',
        '& label, fieldset': {
            paddingLeft: 30,
        },
        '& .MuiOutlinedInput-root': {
            paddingLeft: 30,
        },
        '& ~ div': {
            top: 17
        }
    },
    errorBox: {
        borderColor: `${theme.palette.colors.dangerMain} !important`,
        '& *': {
            color: theme.palette.colors.dangerMain + ' !important',
            '& .MuiButtonBase-root': {
                border: '1px solid '+ theme.palette.colors.dangerMain
            }
        }
    },
    dangerTxt: {
        color: `${theme.palette.colors.dangerMain} !important`,
        marginLeft: '15px !important'
    },
    imageDropArea: {
        borderRadius: 10,
        border: '1px dashed var(--grey-100)',
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 146,
        transition: 'all 0.3s ease',
        padding: '20px',
        boxSizing: 'border-box'
    },
    dragging: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderColor: theme.palette.primary.main,
        borderStyle: 'dashed'
    },
    hasFile: {
        height: 'auto',
        padding: '15px'
    },
    selectFileBtn: {
        border: '1px solid ' + theme.palette.colors.blueMain,
        color: theme.palette.colors.blueMain,
        fontWeight: 700,
        width: 135,
        height: 40,
        textTransform: 'capitalize',
        fontSize: 16,
        position: 'relative',
        '& input': {
            opacity: 0,
            position: 'absolute',
            zIndex: 999,
            cursor: 'pointer',
            height: 40
        }
    },
    dropAreaText: {
        color: 'var(--grey-100)',
        margin: "13px 0px !important"
    },
    previewContainer: {
        width: '100%',
        display: 'flex',
        marginTop: 15,
        flexDirection: 'row',
        alignItems: 'center'
    },
    imagePreview: {
        maxWidth: '180px',
        maxHeight: '101px',
        objectFit: 'contain',
        borderRadius: '4px',
        marginBottom: '10px',
        marginRight: 15
    },
    previewActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginTop: '10px'
    },
    fileName: {
        maxWidth: '70%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    removeBtn: {
        width: 169,
        height: 42,
        marginTop: 10,
        border: '1px solid ' + theme.palette.colors.dangerMain,
        color: theme.palette.colors.dangerMain,
        fontWeight: 700,
        fontSize: 16,
        textTransform: 'capitalize'
    },
    errorText: {
        marginTop: '8px'
    },
    mainWrapper: {
        '& .modal-footer': {
            flexFlow: 'row-reverse'
        }
    }
});
